import { isString } from 'lodash';

import i18n from 'src/locales/i18n';

import { TenantType } from 'src/types/enums';
import { BusinessErrorCodes } from 'src/types/business-errors';

import { AuthContext } from './auth.types';
import { AccountRole } from '../organisation/organisation.enum';

export const Business_Tenants = [TenantType.Client, TenantType.Recruiter];

export const getOrgTenant = (authContext: AuthContext) => authContext.organization.type;

export const isOrganisationTenant = (tenant: TenantType) => Business_Tenants.includes(tenant);

export const isAdmin = (authContext: AuthContext) =>
  [AccountRole.Op_Manager, AccountRole.Admin].includes(authContext.account.org_role);

export const getLoginErrorMessage = (e: any): string => {

  if (isString(e?.data?.error_code)) {
    if (e.data?.error_code === BusinessErrorCodes.AccountLocked) {
      return i18n.t('auth.api.login.account_locked');
    }
    if (e.data?.error_code === BusinessErrorCodes.TenantArchived) {
      return i18n.t('auth.api.login.account_archived');
    }
  }

  return i18n.t('auth.api.login.incorrect');
};
